import api from './api';
class PeriodService {
    getPeriods() {
        return api.get('/api/v1/period' );
    }
    getPeriod(id) {
        return api.get('/api/v1/period/'+id);
    }
    remove(id) {
        return api.delete('/api/v1/period/'+id);
    }
    update(id,form) {
        return api.put('/api/v1/period/'+id,form);
    }
    setDefault(id) {
        return api.put('/api/v1/period/'+id+'/default');
    }
    refresh(id) {
        return api.put('/api/v1/period/'+id+'/refresh');
    }
    create(form) {
        return api.post('/api/v1/period',form);
    }
}
export default new PeriodService();
